import React from "react";

const holder = {
  closeDropdownSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false, searchTerm: '' });
      document.removeEventListener("mousedown", holder.closeDropdownSelector)
    }
  }
};

export default {
  'Dropdown.Selector': async ({ isOpen, containerRef, inputRef, disabled }, _, internalStateSetter) => {
    if (disabled) return;
    let newInputRef = inputRef;
    let newContainerRef = containerRef;

    if (!inputRef || !containerRef) {
      newInputRef = React.createRef();
      newContainerRef = React.createRef();
      await internalStateSetter({ inputRef: newInputRef, containerRef: newContainerRef });
    }

    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;

    await internalStateSetter({ isOpen: !isOpen, searchTerm: '' });
    if (isOpen) {
      document.removeEventListener("mousedown", holder.closeDropdownSelector);
    } else {
      inputRef?.current?.children?.[0]?.focus();
      document.addEventListener("mousedown", holder.closeDropdownSelector);
    }
  },
  'Dropdown.Selector.ButtonsWrapper.AddButtonWrapper.AddNew': ({ action }, outlet) => {
    outlet({ buttonAction: action })
  },
  'Dropdown.Selector.LeftSide.Wrapper.SearchInput': ({ value, disabled }, _, internalStateSetter) => {
    if (disabled) return;
    internalStateSetter({ searchTerm: value, isOpen: true })
  },
  'Dropdown.Selector.LeftSide.Wrapper.SearchInput(Keydown)': () => {
  },
  'Dropdown.Selector.LeftSide.Wrapper.SelectedButton': ({ selectedOptionId, selectedOptionIds }, outlet) => {
    outlet({ selectedOptionIds: selectedOptionIds.filter(id => id !== selectedOptionId) })
  },
  'Dropdown.Body.Option': ({ option, selectedOptionIds, multipleSelect, inputRef }, outlet, internalStateSetter) => {
    if (multipleSelect) {
      if (selectedOptionIds.includes(option.id)) {
        outlet({ selectedOptionIds: selectedOptionIds.filter(id => id !== option.id) })
      } else {
        outlet({ selectedOptionIds: [...selectedOptionIds, option.id] })
      }
      inputRef?.current?.children?.[selectedOptionIds.length]?.focus();
      internalStateSetter('isOpen', false);
    } else {
      outlet({ selectedOptionIds: option.id === selectedOptionIds[0] ? [] : [option.id] })
      internalStateSetter('isOpen', false);
    }
    internalStateSetter({ searchTerm: '' })
  }
}